import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "features/user/userSlice";
import appVersionReducer from "features/appVersion/appVersionSlice";

export default combineReducers({
  user: userReducer,
  appVersion: appVersionReducer,
});
